import Vue from 'vue';
import router from './router';
import store from './store';
import './api';
import './plugins/axios';
import 'normalize.css';
import './plugins/sweet';
import './plugins/element';
import AppCloudLayout from '@/views/app-cloud-layout/index.vue';

Vue.config.productionTip = false;

// 自动聚焦
Vue.directive('focus', {
  inserted(el) {
    el.querySelector('input').focus();
  },
});

// 国际化启动之后，进行vue实例化
store.dispatch('initLang').then(i18n => new Vue({
  // el: '#app',
  router,
  store,
  i18n,
  render: h => h(AppCloudLayout),
}).$mount('#app'));
